var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"align":"center"}},[_c('h1',[_vm._v(" "+_vm._s(this.titre)+" ")]),_c('p',[_vm._v("Coach: "+_vm._s(this.coach)+" ")]),_c('p',[_vm._v("Debut: "+_vm._s(this.debut)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }